import React from "react";

const ConsultationAreaTwo = () => {
  return (
    <section className="consultation-area consultation-area-two pt-120 pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="consultation-content">
              <div className="section-title mb-25">
                <span className="sub-title">Waarom Vernu?</span>
                <h2 className="title">
                  Meubelstoffering met Hart en Vakmanschap
                </h2>
              </div>

              <p>
                Bij Vernu Stoffering draait alles om kwaliteit, duurzaamheid en persoonlijke service. Wij combineren traditioneel vakmanschap met moderne technieken om jouw meubels nieuw leven in te blazen — met respect voor materiaal én verhaal.
              </p>

              <div className="consultation-list">
                <ul className="list-wrap">
                  <li>
                    <h6 className="title">100%</h6>
                    <p>
                      Handgemaakt <span>en Maatwerk</span>
                    </p>
                  </li>
                  <li>
                    <h6 className="title">30+</h6>
                    <p>
                      Stoffen <span>en Materialen</span>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="col-lg-5">
            <div className="consultation-form-wrap">
              <h4 className="title">Meer weten?</h4>
              <p>
                Neem gerust contact met ons op of ontdek onze projecten en reviews. Wij staan klaar om jouw interieurproject tot een succes te maken.
              </p>
              <a href="/contact" className="btn" style={{ marginTop: "20px" }}>
                Contact opnemen
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="consultation-shape-wrap" aria-hidden="true">
        <img
          src="/img/images/consultation_shape01.png"
          alt="Icon die beweegt"
          className="shape-one ribbonRotate"
        />
        <img
          src="/img/images/consultation_shape02.png"
          alt="Icon die beweegt"
          className="shape-two float-bob-x"
        />
      </div>
    </section>
  );
};

export default ConsultationAreaTwo;
